import Vue from "vue";
/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 * Delete invoce that has no sinisters
 * @param  id Invoice id
 */

const deleteInvoice = ({ id }) =>
  Vue.$http.delete(`taxreceipt/taxreceipt/${id}/`).catch((err) => {
    throw err;
  });

export default deleteInvoice;



// WEBPACK FOOTER //
// ./src/services/taxReceipt/deleteInvoice.js